import UsersStore from './users';
import PostsStore from './posts';
import SingleProducerMeetingsStore from './single-producer-meetings';

class Stores {

  constructor(application, serverInterface) {

    this.users = new UsersStore(application, serverInterface);
    this.posts = new PostsStore(application, serverInterface);
    this.singleProducerMeetings = new SingleProducerMeetingsStore(application, serverInterface);

  }

}

export default Stores;